import {classify,followingDraws} from './analysis';

// Fixed experimental parameters, not tuned on the displayed backtest.
export const MODEL = Object.freeze({version:'continuous-reference-60-v4',window:60,minConditional:5,weight:20});
export const GROUPS=['大单','大双','小单','小双'];
const groupOf=(draw,kind)=>classify(draw,kind,'size')+classify(draw,kind,'parity');
const countsOf=(draws,kind)=>draws.reduce((counts,draw)=>{
  const index=GROUPS.indexOf(groupOf(draw,kind));
  if(index>=0) counts[index]++;
  return counts;
},[0,0,0,0]);
const sum=values=>values.reduce((a,b)=>a+b,0);
export function localPrediction(history,kind) {
  const sample=history.slice(0,kind==='six'?100:MODEL.window);
  const base=countsOf(sample,kind);
  const conditional=countsOf(followingDraws(sample,kind),kind);
  const baseTotal=sum(base),total=sum(conditional);
  const hasGap=sample.some((draw,i)=>i>0&&Number(sample[i-1].issue)-Number(draw.issue)!==1);
  const mode=baseTotal===0?'default':hasGap||total<MODEL.minConditional?'baseline':'smoothed';
  const rows=GROUPS.map((group,index)=>{
    const baseline=(base[index]+1)/(baseTotal+GROUPS.length);
    return {group,baseline,count:conditional[index],score:mode==='smoothed'?(conditional[index]+MODEL.weight*baseline)/(total+MODEL.weight):baseline};
  });
  // Fixed, documented ordering resolves ties without random changes on refresh.
  const ranked=[...rows].sort((a,b)=>b.score-a.score || GROUPS.indexOf(a.group)-GROUPS.indexOf(b.group));
  const choices=ranked.slice(0,2).map(row=>row.group),excluded=ranked[3].group;
  const reason=mode==='default'?'默认参考 · 暂无历史数据':mode==='baseline'?(hasGap?'整体频率参考 · 历史存在缺期':'整体频率参考 · 后续样本较少'):'平滑统计参考';
  const pick=(values,score)=>[...values].sort((a,b)=>score(b)-score(a))[0];
  const size=pick(['大','小'],value=>rows.filter(row=>row.group.startsWith(value)).reduce((a,b)=>a+b.score,0));
  const parity=pick(['单','双'],value=>rows.filter(row=>row.group.endsWith(value)).reduce((a,b)=>a+b.score,0));
  const nextDraws=followingDraws(sample,kind);
  const dragonBase=['龙','虎'].map(value=>sample.filter(draw=>classify(draw,kind,'dragon')===value).length);
  const dragonNext=['龙','虎'].map(value=>nextDraws.filter(draw=>classify(draw,kind,'dragon')===value).length);
  const dragonTotal=dragonNext[0]+dragonNext[1],dragonBaseTotal=dragonBase[0]+dragonBase[1];
  const dragonScores=['龙','虎'].map((value,i)=>{
    const baseline=(dragonBase[i]+1)/(dragonBaseTotal+2);
    return {value,score:!hasGap&&dragonTotal>=MODEL.minConditional?(dragonNext[i]+MODEL.weight*baseline)/(dragonTotal+MODEL.weight):baseline};
  });
  const dragon=[...dragonScores].sort((a,b)=>b.score-a.score)[0].value;
  return {version:MODEL.version,rows,baseTotal,total,choices,excluded,mode,reason,conditionIssue:sample[0]?.issue,
    attributeChoices:kind==='pc'?{size,parity,dragon}:undefined};
}

export function backtestLocal(history,kind) {
  if(kind==='pc') history=history.slice(0,MODEL.window);
  const records=[];
  const groups={hits:0,count:0,baselineHits:0},kill={hits:0,count:0,baselineHits:0};
  // Each target uses only older draws. No parameter search or retrospective replacement.
  for(let i=0;i<Math.min(200,history.length-1);i++) {
    const actual=groupOf(history[i],kind);
    const training=history.slice(i+1);
    const prediction=localPrediction(training,kind);
    const contiguous=Number(history[i].issue)-Number(training[0].issue)===1;
    const valid=contiguous&&prediction.mode!=='default'&&GROUPS.includes(actual);
    const baseline=[...prediction.rows].sort((a,b)=>b.baseline-a.baseline);
    const choiceHit=valid&&prediction.choices?prediction.choices.includes(actual):null;
    const excludedHit=valid&&prediction.excluded?prediction.excluded!==actual:null;
    if(choiceHit!==null){groups.count++;groups.hits+=Number(choiceHit);groups.baselineHits+=Number(baseline.slice(0,2).some(row=>row.group===actual));}
    if(excludedHit!==null){kill.count++;kill.hits+=Number(excludedHit);kill.baselineHits+=Number(baseline[3].group!==actual);}
    records.push({issue:history[i].issue,actual,choices:prediction.choices,excluded:prediction.excluded,choiceHit,excludedHit});
  }
  return {records,groups,kill,checked:records.length};
}
